if(process.env.NODE_ENV && process.env.NODE_ENV == 'development'){
    module.exports = require('JS/store/middleware.dev');
} else {
    module.exports = require('JS/store/middleware.prod');
}